module.exports = __webpack_public_path__ + "img/lens-150-minus-07.f0893681.png";